// store/selectedComponentsSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ComponentInfo {
  file: string | null;
  line: string | null;
  col: string | null;
  rawSource: string | null;
  data: any;
}

interface SelectedComponentsState {
  components: ComponentInfo[];
}

const initialState: SelectedComponentsState = {
  components: [],
};

const selectedComponentsSlice = createSlice({
  name: "selectedComponents",
  initialState,
  reducers: {
    addComponent: (state, action: PayloadAction<ComponentInfo>) => {
      // replace the previously selected component with the new one
      state.components = [action.payload];
    },
    removeComponent: (state, action: PayloadAction<string>) => {
      state.components = state.components.filter(
        (c) => c.rawSource !== action.payload
      );
    },
    clearComponents: (state) => {
      state.components = [];
    },
  },
});

export const { addComponent, removeComponent, clearComponents } =
  selectedComponentsSlice.actions;
export default selectedComponentsSlice.reducer;
